import ScriptingEffect from './ScriptingEffect.js';
import {pipe} from './pipe.js';
import {alt} from './alt.js';
import {
    switchOutput,
    execute,
    notes,
    steps,
    prob,
} from './lang.js';

class AltEffect extends ScriptingEffect {
    constructor(track) {
        super("Alternate", track);
        this.clear();

        this.numberOfOutputs = 2;
    }

    get documentation() {
        return [
            "Alternates the 2 outputs every other trigger."
        ];
    }

    isRealTime() {
        return false;
    }

    clear() {
        this.myScript = pipe(
            alt(switchOutput(0), switchOutput(1)));
    }

    get script() {
        return this.myScript;
    }

    getCopy(track, ignoreId=true) {
        let fx = new AltEffect(track);
        fx.fromJson(fx.getJson(), ignoreId);
        return fx;
    }
}


export default AltEffect;
